/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/checkCircle.svg
 */
import type { IconProps } from '../types';
const CheckCircle = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="m7.668 12.333 3 3.334 5.667-7.334m5.319 3.672c0 5.338-4.328 9.666-9.667 9.666S2.32 17.343 2.32 12.005c0-5.34 4.328-9.667 9.667-9.667s9.667 4.328 9.667 9.667"
    />
  </svg>
);
export default CheckCircle;
